import React from "react";
import { getHumanReadableTimePassedSinceThisInstance } from "Utils/Common";
import logger from "logger";

export default function(props) {
  const { instanceMillis } = props;
  const [timeString, setTimeString] = React.useState(null);

  React.useEffect(() => {
    const timer = setInterval(() => {
      var timeString = getHumanReadableTimePassedSinceThisInstance(
        instanceMillis
      ).timeString;
      setTimeString(timeString);
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return timeString;
}
